export default __webpack_public_path__ + "8e79772e4b10c0b9d3e121eac9158eb6.png";